import React from "react";

import Countdown from "react-countdown-now";

import DevelopmentImg from "../../assets/images/coming/under-development.png";
import GitImg from "../../assets/images/coming/git.svg";
import ReactImg from "../../assets/images/coming/react.svg";
import PlanningImg from "../../assets/images/coming/planning.svg";
import WebDevelopmentImg from "../../assets/images/coming/web-development.svg";

import "./coming.scss";

function illustrationResolver(name) {
  switch (name) {
    case "development":
      return DevelopmentImg;
    case "react":
      return ReactImg;
    case "git":
      return GitImg;
    case "planning":
      return PlanningImg;
    case "web-development":
      return WebDevelopmentImg;
    default:
      return name;
  }
}

export default function ComingSoon({
  image,
  bgColor,
  textColor,
  illustration,
  title,
  subtitle,
  date,
  children,
  ...rest
}) {
  
  console.log(rest);
  return (
    <section
      className="fullpage"
      style={{
        backgroundImage: image ? `url(${image})` : "",
        backgroundColor: bgColor ? bgColor : "#fff",
        color: textColor ? textColor : "#000",
      }}
    >
      <div className="content">
        <div>
          <img
            src={illustrationResolver(illustration)}
            alt="WebDevelopmentImg"
          />
          <h1>{title ? title : "Coming Soon"} </h1>
          <p>{subtitle}</p>
          {children}
          {date ? (
            <Countdown
              date={date}
              renderer={(props) => (
                <div className="countdown">
                  <div style={{ borderColor: textColor ? textColor : "#000" }}>
                    <h3>{props.seconds}</h3>
                    <p>ثواني</p>
                  </div>
                  <div style={{ borderColor: textColor ? textColor : "#000" }}>
                    <h3>{props.minutes}</h3>
                    <p>دقائق</p>
                  </div>
                  <div style={{ borderColor: textColor ? textColor : "#000" }}>
                    <h3>{props.hours}</h3>
                    <p>ساعات</p>
                  </div>
                  {props.days ? (
                    <div
                      style={{ borderColor: textColor ? textColor : "#000" }}
                    >
                      <h3>{props.days}</h3>
                      <p>أيام</p>
                    </div>
                  ) : null}
                </div>
              )}
            />
          ) : null}
        </div>
      </div>
    </section>
  );
}
